var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-grid-view-item"},[_c('div',{staticClass:"c-grid-view-item__preview",on:{"click":function($event){return _vm.$emit('click')},"dblclick":function($event){return _vm.$emit('dblclick')}}},[_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-grid-view-item__preview--item"},[_c('i',{staticClass:"fas fa-plus-circle add-icon"})])
}]

export { render, staticRenderFns }